import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getMetrics, createMetric, updateMetric } from '@lingaai/supabase-client';
import type { Metric } from '@lingaai/types';

export function useMetrics(submissionId: string) {
  return useQuery({
    queryKey: ['metrics', submissionId],
    queryFn: () => getMetrics(submissionId),
    enabled: !!submissionId,
  });
}

export function useCreateMetric() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: Omit<Metric, 'id' | 'created_at' | 'updated_at'>) => createMetric(input),
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: ['metrics', data.submission_id],
      });
    },
  });
}

export function useUpdateMetric() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (variables: { metricId: string; updates: Partial<Metric> }) => updateMetric(variables.metricId, variables.updates),
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: ['metrics', data.submission_id],
      });
      queryClient.invalidateQueries({
        queryKey: ['submission-details', data.submission_id],
      });
    },
  });
}
